module.exports = __webpack_public_path__ + "static/media/Take the tour General.593a2e93.mp4";